import DocumentTitle from "react-document-title";
import { useTranslation } from "react-i18next";
import PageHeader from "../components/PageHeader";
import { useEffect, useState } from "react";
import { Unit } from "../components/UnitCard";
import UnitcompletedChecklistList from "../components/UnitcompletedChecklistList";
import axios from "axios";
import moment, { Moment } from "moment";
import { Button, ButtonGroup } from "flowbite-react";
import Swal from "sweetalert2";

export interface WeeklyNote {
    id: number,
    unit: Unit,
    weekStart: Date,
    note: string,
}

export interface UncompletedData {
    unit: Unit,
    weeklyNote?: WeeklyNote,
};

function UncompletedChecklists() {
    const [t] = useTranslation('common');
    const [startDate, setStartDate] = useState<Moment|null>(null);
    const [endDate, setEndDate] = useState<Moment|null>(null);
    const [uncompletedChecklists, setUncompletedChecklists] = useState<UncompletedData[]>([]);

    const [weekStartDate, setWeekStartDate] = useState<Moment|null>(null);

    const fetchUncompletedChecklists = () => {
        Swal.showLoading();
        axios.get("/checklists/uncompleted", {
            params: {
                startDate: weekStartDate
            }
        }).then((response) => {
            setUncompletedChecklists(response.data.uncompleteds);
            setStartDate(moment(response.data.startDate));
            setEndDate(moment(response.data.endDate));
            setWeekStartDate(moment(response.data.startDate));
            Swal.close();
        }).catch((err) => {
            console.log(err);
        });
        
    };

    useEffect(() => {
        if(!weekStartDate?.isSame(startDate)){
         fetchUncompletedChecklists();   
        }
    }, [weekStartDate]);

    const handleNoteSaved = () => {
        fetchUncompletedChecklists();
    };

    const title = t("Welcome to", { app: process.env.REACT_APP_NAME });
    return (
        <div className="flex min-h-full flex-col px-4 lg:px-8 ">
            <DocumentTitle title={title}></DocumentTitle>
            <div className="page-center">
                <PageHeader title={title} />
            </div>
            <div className="page-body mt-[103px]">
                <div className="page-center">
                    <div className="unit w-full text-center py-3">
                        <div className="unit-icon mx-auto max-w-[65px]">
                            <img className="max-w-full h-auto mx-auto" src="/assets/img/unit-icon.png" alt="Unit Icon" />
                        </div>
                        <div className="unit-text text-center">
                            <h3 className="mt-1 text-lg font-medium capitalize text-sablack">Uncompleted Checklists </h3>
                            <p className="mt-1 text-[13px] font-light text-sablack">Add comment to units that has not checklist.</p>
                            <div className="flex items-center justify-center gap-4 mt-2">
                                <ButtonGroup outline>
                                    <Button
                                        size={'xs'}
                                        onClick={() => setWeekStartDate(prev => prev ? moment(prev).subtract(1, 'week') : moment().startOf('week').subtract(1, 'week'))}
                                        aria-label="Previous Week"
                                    >
                                        <i className="ri-arrow-left-s-line"></i>
                                    </Button>
                                    <Button disabled size={'xs'}>
                                        {startDate?.format('DD MMM YYYY')} - {endDate?.format('DD MMM YYYY')}
                                    </Button>
                                    <Button 
                                        size={'xs'}
                                        onClick={() => setWeekStartDate(prev => prev ? moment(prev).add(1, 'week') : moment().startOf('week').add(1, 'week'))}
                                        aria-label="Next Week"
                                        disabled={weekStartDate?.isSameOrAfter(moment().subtract(2, 'week'))}
                                    >
                                        <i className="ri-arrow-right-s-line"></i>
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </div>
                    </div>
                    <div className="unit-alt px-3">
                        <UnitcompletedChecklistList 
                            uncompletedChecklists={uncompletedChecklists} 
                            weekDate={startDate}
                            onNoteSaved={handleNoteSaved}
                        />
                    </div>
                </div>
            </div>
        </div>


    )
}

export default UncompletedChecklists;